module.exports = ".card{margin-left:1rem;margin-bottom:1rem;height:22rem}.card-header{padding:0.3rem;font-size:0.7rem}.card-body{padding:0.3rem;font-size:0.7rem;height:100%;overflow-y:auto}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/report/report.component.sass
// module id = ./src/app/modules/dashboard/report/report.component.sass
// module chunks = main